import React, { useCallback, useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { BackTop, Button, Checkbox, Divider } from 'antd';
import GlobalService from '../../../../services/Global.service';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import TemplateDesignService from '../../../../services/TemplateDesign.service';
import months from '../../months.json';
import IconNoData from '../../../../assets/Images/icons/icon-no-data';
import Complete from './Complete';
import moment from 'moment';
import useQuery from '../../../../util/useQuery';
import classNames from 'classnames';
import { sendHeightToIframeConsent } from '../../../policy/sendHeight';

export default function TermCondition() {
    // key test dd4c125e4bb342898b9

    const { key, lang } = useParams();
    const [imageSrc, setImageSrc] = useState([]);
    const [isAccept, setIsAccept] = useState(false);
    const [imageId, setImageId] = useState();
    const [consent, setConsent] = useState();
    const [selectDocLayout, setSelectDocLayout] = useState();
    const [templateDetail, setTemplateDetail] = useState();
    const [isSubmit, setIsSubmit] = useState(false);
    const params = useQuery();

    const ref = useRef();

    const Title = styled.div`
        font-weight: 600 !important;
    `;

    const CheckCustom = styled.div`
        .ant-checkbox-checked .ant-checkbox-inner {
            background-color: #1890ff;
            border: 1px solid #1890ff;
        }
        .ant-checkbox-checked:hover .ant-checkbox-inner:hover {
            border-color: #1890ff;
            border: 1px solid #1890ff;
        }
        .ant-checkbox-input:focus + .ant-checkbox-inner,
        .ant-checkbox-wrapper:hover .ant-checkbox-inner,
        .ant-checkbox:hover .ant-checkbox-inner {
            border-color: #1890ff;
        }
        .ant-checkbox-checked:hover {
            border-color: #1890ff !important;
        }
    `;

    const TemplateDetail = styled.div`
        a {
            color: #1890ff !important;
        }
    `;

    const getTemplateDetail = async () => {
        try {
            const { data } =
                await TemplateDesignService.getTemplateTermAndConditionPublishNoSecure(
                    key
                );
            const item = data?.resultData;
            setConsent(item?.purpose);
            setSelectDocLayout(item?.showAcknowledgeButton ? 2 : 1);
            setTemplateDetail(item);
            setImageId(item?.logoId);
            sendHeightToIframeConsent(ref.current);
        } catch (error) {}
    };

    useEffect(() => {
        getTemplateDetail();
        if (params.get('ember') === '1') {
            document.body.style.background = 'transparent';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const getImage = async () => {
            try {
                const { data } = await GlobalService.getImageNoSecure(imageId);
                if (data.resultData?.imageId) {
                    setImageSrc(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (imageId) getImage();
        else setImageSrc(null);
    }, [imageId]);

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'th' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'th' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const currentDate = new Date(date);
        const day = currentDate.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    const onFinish = async () => {
        const acceptance = [];
        acceptance.push({
            consentId: consent?.consentId,
            identity: '',
            isAccept: isAccept,
            collectionPointName: '',
            // version: consent?.version,
        });
        try {
            const { data } =
                await TemplateDesignService.addNewTemplateAcceptance({
                    templateId: templateDetail?.templateId,
                    acceptance: acceptance,
                });
            if (data?.resultMsg === 'SUCCESS') {
                console.log('data ', data);
                setIsSubmit(true);
            } else {
                setIsSubmit(false);
            }
        } catch (error) {
            setIsSubmit(false);
        }
    };

    return (
        <div className="w-full h-full">
            {!isSubmit ? (
                <>
                    {templateDetail ? (
                        <div
                            ref={ref}
                            className={classNames({
                                'm-0 w-full': params.get('ember') === '1',
                                'max-w-6xl m-auto my-5 border-[1px] border-solid border-[#ECECEC] rounded-md':
                                    !params.get('ember'),
                            })}
                        >
                            <div className="whitespace-pre-line m-4 mt-2 px-5 py-6 leading-7">
                                {imageSrc && (
                                    <center>
                                        <img
                                            className="object-cover rounded"
                                            src={imageSrc}
                                            height={70}
                                            alt={templateDetail?.titleEn}
                                        />
                                    </center>
                                )}
                                <Title className="text-[#1E1E1E] text-xl text-center pt-3">
                                    {lang === 'th'
                                        ? parse(
                                              templateDetail?.titleTh || ''
                                          ) || ''
                                        : parse(
                                              templateDetail?.titleEn || ''
                                          ) || ''}
                                </Title>
                                <Divider className="my-4" />
                                <div>
                                    <Title>
                                        {lang === 'th'
                                            ? parse(
                                                  templateDetail?.templateNameTh ||
                                                      ''
                                              ) || ''
                                            : parse(
                                                  templateDetail?.templateNameEN ||
                                                      ''
                                              ) || ''}
                                    </Title>
                                    <TemplateDetail>
                                        {lang === 'th'
                                            ? parse(consent?.purposeTh || '') ||
                                              ''
                                            : parse(consent?.purposeEn || '') ||
                                              ''}
                                    </TemplateDetail>
                                </div>
                                <div className="text-sm font-base whitespace-pre-wrap my-4">
                                    {lang === 'en'
                                        ? 'This document was last updated on'
                                        : 'เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อ'}{' '}
                                    {templateDetail?.effectiveDate
                                        ? getCurrentDate(
                                              // 2023-05-03T17:51:51Z ex date from service
                                              moment(
                                                  templateDetail?.effectiveDate
                                              )
                                                  ?.format(
                                                      'YYYY-MM-DDT00:00:00.000+00:00'
                                                  )
                                                  ?.split('T')[0] || '-'
                                          )
                                        : '-'}
                                </div>
                                <CheckCustom
                                    hidden={selectDocLayout !== 2}
                                    className="mt-3"
                                >
                                    <Checkbox
                                        className="bg-[#F4F6FC] rounded-md px-3 py-[10px]"
                                        checked={isAccept}
                                        style={{
                                            '--checkbox-color': '#1890FF',
                                        }}
                                        onChange={(e) => {
                                            setIsAccept(e.target.checked);
                                        }}
                                    >
                                        <div>
                                            {lang === 'en'
                                                ? 'Agree to the terms and conditions.'
                                                : 'รับทราบข้อกำหนดและเงื่อนไข'}
                                        </div>
                                    </Checkbox>
                                    <Divider className="my-3" />
                                    <div className="font-semibold">
                                        {lang === 'en'
                                            ? 'Provide consent information as of (date)'
                                            : 'ให้ข้อมูลความยินยอม ณ วันที่'}{' '}
                                        {getCurrentDate(new Date())}
                                    </div>
                                    <div className="mt-4 text-center">
                                        <Button
                                            onClick={onFinish}
                                            className="px-9 bg-[#1890ff] border border-solid border-[#1890ff] 
                                                hover:bg-[#1890ff] hover:opacity-75 hover:border hover:border-solid hover:border-[#1890ff]
                                                focus:bg-[#1890ff] focus:opacity-75 focus:border focus:border-solid focus:border-[#1890ff]"
                                            size="large"
                                            type="primary"
                                            disabled={!isAccept}
                                        >
                                            {lang === 'en'
                                                ? 'Submit'
                                                : 'ยืนยัน'}
                                        </Button>
                                    </div>
                                </CheckCustom>
                            </div>
                        </div>
                    ) : (
                        <div className="bg-white rounded-md whitespace-pre-line border-solid border-[#ECECEC] p-6 mt-2 leading-7 overflow-auto max-h-[700px]">
                            <div className="text-center text-sm space-y-2 my-56">
                                <IconNoData />
                                <p className="text-[#65707A] text-[14px]">
                                    {lang === 'en' ? 'No Data' : 'ไม่พบข้อมูล'}
                                </p>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <Complete />
            )}

            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#1890FF',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
